import React, { useEffect } from 'react';
import { ModalBase } from '@panel/commons';
import PerformanceTips from '@panel/commons/lib/Modals/PerformanceTips';
import PrintModal from '@panel/commons/lib/Modals/PrintModal';
import ReportsModal from '@panel/commons/lib/Modals/ReportsModal';
import { sendTrackingInfo, sendCustomTrackingInfo } from '@panel/commons/lib/sendTrackingInfo';
import EndModal from '@panel/commons/lib/Modals/EndModal';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '../../Modals/ModalWrapper';
import PublishModal from '../../Modals/PublishModal';
import IntegratorModal from '../../Modals/IntegratorModal';
import LockedSoftModal from '../../Modals/LockedSoftModal';
import ArchiveModal from '../../Modals/ArchiveModal';
import SocialAdsModal from '../../Modals/SocialAdsModal';
import UpgradePlanModal from '../../Modals/UpgradePlanModal';
import HistoryModal from '../../Modals/HistoryModal';
import { PostingsOperations } from '../../../../ducks/posting';
import { ReservationOperations } from '../../../../ducks/reservation';
import { UnreadLeadsMsgOperations, UnreadLeadsMsgSelectors } from '../../../../ducks/unreadLeadsMsg';
import { SuspendOperations, SuspendSelectors } from '../../../../ducks/suspend';
import { ArchiveSelectors } from '../../../../ducks/archive';

const ModalsArea = ({
  showModal,
  setShowModal,
  posting,
  isFreePlan,
  publisherTypeId,
  redirectToEdit,
  socialAdsReport,
  isOnline,
  isDraft,
  isDuplicate,
  hasReportsUnchecked,
  fetchReports,
  postingLogs,
  isIntegrator,
  setFinishedAction,
  isAssistant,
  finishReason,
  loadingFinishReason,
  loadingCredits,
  device
}) => {
  const {
    lockedSoft,
    endModal,
    activationModal,
    performanceTips,
    archiveModal,
    integratorModal,
    reportModal,
    socialAdsReportModal,
    upgradePlanModal,
    historyModal,
    printModal
  } = showModal;

  const { postingId, publicationType, validations } = posting;
  const dispatch = useDispatch();
  const { checkReport } = PostingsOperations;
  const { savePostingTag } = ReservationOperations;
  const { isLoading, recievedSuccessfulResponse } = useSelector(SuspendSelectors.getSuspendState);
  const { hasUnreadLeadsLoading, hasUnreadLeads } = useSelector(UnreadLeadsMsgSelectors.getUnreadLeadsMsgState);
  const { isLoading: archiveIsLoading, recievedSuccessfulResponse: archiveRecievedSuccessfulResponse } = useSelector(
    ArchiveSelectors.getArchiveState
  );
  const operationType = posting.pricesOperationTypes[0] && posting.pricesOperationTypes[0].operationType;

  const particularNotFree = !isFreePlan && publisherTypeId === '1';

  const { t } = useTranslation();

  const handlePrintCTA = () => {
    sendTrackingInfo('Panel', 'Mis avisos', 'Imprimir-Notificar');
    setFinishedAction({
      postingId: '',
      action: 'print',
      result: 'SUCCESS',
      component: t('panel.avisos.print.snackbar.SUCCESS'),
      keepOpen: false
    });
  };

  useEffect(() => {
    // Se consume servicio para validar si el aviso tiene consultas sin responder, para el modal de finalización:
    if (endModal) {
      dispatch(UnreadLeadsMsgOperations.getUnreadLeads(postingId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endModal]);

  useEffect(() => {
    /**
     *  Se valida si el posting está online y luego se consume servicio para conocer
     *  si tiene consultas sin responder para el modal de archivar.
     */
    if (archiveModal && isOnline) {
      dispatch(UnreadLeadsMsgOperations.getUnreadLeads(postingId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [archiveModal, isOnline]);

  return (
    <>
      {lockedSoft && (
        <Modal>
          <ModalBase
            openModal={lockedSoft}
            onClose={() => setShowModal({ ...showModal, lockedSoft: false })}
            width='328px'
            height='399px'
          >
            <LockedSoftModal onClose={() => setShowModal({ ...showModal, lockedSoft: false })} />
          </ModalBase>
        </Modal>
      )}
      {endModal && (
        <Modal>
          <ModalBase
            openModal={endModal}
            onClose={() => {
              setShowModal({ ...showModal, endModal: false });
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Finalizar Aviso-finalizar_cerrar'
              });
            }}
            isLoading={loadingFinishReason || isLoading || recievedSuccessfulResponse || hasUnreadLeadsLoading}
            withoutOutsideClose
          >
            <EndModal
              hasDuplicate={posting.isDuplicate}
              particularNotFree={particularNotFree}
              onClose={() => setShowModal({ ...showModal, endModal: false })}
              postingId={postingId}
              publisherTypeId={publisherTypeId}
              finishReason={finishReason}
              SuspendOperations={SuspendOperations}
              UnreadLeadsMsgOperations={UnreadLeadsMsgOperations}
              hasUnreadLeads={hasUnreadLeads}
            />
          </ModalBase>
        </Modal>
      )}
      {activationModal && (
        <Modal>
          <ModalBase
            openModal={activationModal}
            onClose={() => setShowModal({ ...showModal, activationModal: false })}
            width='400px'
            isLoading={loadingCredits}
          >
            <PublishModal
              onClose={() => setShowModal({ ...showModal, activationModal: false })}
              postings={[postingId]}
              publicationType={publicationType}
              operationType={operationType}
              isDraft={isDraft}
              redirectToEdit={redirectToEdit}
              postingList={[posting]}
              isIntegrator={isIntegrator}
              publisherTypeId={publisherTypeId}
              device={device}
            />
          </ModalBase>
        </Modal>
      )}
      {performanceTips && (
        <Modal>
          <ModalBase
            openModal={performanceTips}
            onClose={() => setShowModal({ ...showModal, performanceTips: false })}
            width='400px'
            height={isAssistant ? '330px' : '400px'}
          >
            <PerformanceTips
              datalayerText='Card del aviso-Completitud del aviso_Ir a editar el aviso'
              tips={validations}
              postingId={postingId}
              isDuplicate={isDuplicate}
              isIntegrator={isIntegrator}
              isAssistant={isAssistant}
              publisherTypeId={publisherTypeId}
              publicationType={publicationType}
            />
          </ModalBase>
        </Modal>
      )}
      {archiveModal && (
        <Modal>
          <ModalBase
            openModal={archiveModal}
            onClose={() => {
              setShowModal({ ...showModal, archiveModal: false });
              sendCustomTrackingInfo({
                event: 'trackEvent',
                eventCategory: 'Panel',
                eventAction: 'Mis avisos',
                eventLabel: 'Archivar Aviso-archivar_cerrar'
              });
            }}
            isLoading={
              loadingFinishReason || archiveIsLoading || archiveRecievedSuccessfulResponse || hasUnreadLeadsLoading
            }
          >
            <ArchiveModal
              onClose={() => setShowModal({ ...showModal, archiveModal: false })}
              postingIds={[postingId]}
              isOnline={isOnline}
              particularNotFree={particularNotFree}
              isDraft={isDraft}
              publisherTypeId={publisherTypeId}
              finishReason={finishReason}
              posting={posting}
              hasUnreadLeads={hasUnreadLeads}
            />
          </ModalBase>
        </Modal>
      )}
      {integratorModal && (
        <Modal>
          <ModalBase
            openModal={showModal.integratorModal}
            onClose={() => setShowModal({ ...showModal, integratorModal: false })}
            width='400px'
            height='400px'
          >
            <IntegratorModal
              redirectToEdit={redirectToEdit}
              onClose={() => setShowModal({ ...showModal, integratorModal: false })}
            />
          </ModalBase>
        </Modal>
      )}
      {reportModal && (
        <Modal>
          <ModalBase
            openModal={showModal.reportModal}
            onClose={() => setShowModal({ ...showModal, reportModal: false })}
            width='fit-content'
            height='fit-content'
          >
            <ReportsModal
              onClose={() => setShowModal({ ...showModal, reportModal: false })}
              isReserved={posting.isReservado}
              postingReports={posting.postingReports}
              redirectToEdit={redirectToEdit}
              isIntegrator={isIntegrator}
              hasReportsUnchecked={hasReportsUnchecked}
              checkReport={() => dispatch(checkReport(postingId))}
              fetchReports={fetchReports}
              savePostingTag={() => dispatch(savePostingTag(postingId, 1))}
              isAssistant={isAssistant}
            />
          </ModalBase>
        </Modal>
      )}
      {socialAdsReportModal && (
        <Modal>
          <ModalBase
            openModal={showModal.socialAdsReportModal}
            onClose={() => setShowModal({ ...showModal, socialAdsReportModal: false })}
            width='550px'
            height='520px'
          >
            <SocialAdsModal socialAdsReport={socialAdsReport} />
          </ModalBase>
        </Modal>
      )}
      {upgradePlanModal && (
        <Modal>
          <ModalBase
            openModal={showModal.upgradePlanModal}
            onClose={() => setShowModal({ ...showModal, upgradePlanModal: false })}
            width='fit-content'
            height='fit-content'
            isLoading={loadingCredits}
          >
            <UpgradePlanModal
              onClose={() => setShowModal({ ...showModal, upgradePlanModal: false })}
              posting={posting}
              publicationType={publicationType}
              operationType={operationType}
              publisherId={posting.publisherId}
              isIntegrator={isIntegrator}
              publisherTypeId={publisherTypeId}
              device={device}
            />
          </ModalBase>
        </Modal>
      )}
      {historyModal && (
        <Modal>
          <ModalBase
            openModal={showModal.historyModal}
            onClose={() => setShowModal({ ...showModal, historyModal: false })}
            width='400px'
            height='fit-content'
            isLoading={posting.loadingLogs}
          >
            <HistoryModal
              postingLogs={postingLogs}
              onClose={() => setShowModal({ ...showModal, historyModal: false })}
              publisherTypeId={publisherTypeId}
            />
          </ModalBase>
        </Modal>
      )}
      {printModal && (
        <Modal>
          <ModalBase
            openModal={printModal}
            onClose={() => setShowModal({ ...showModal, printModal: false })}
            width='400px'
            height='450px'
          >
            <PrintModal onClose={() => setShowModal({ ...showModal, printModal: false })} handleCTA={handlePrintCTA} />
          </ModalBase>
        </Modal>
      )}
    </>
  );
};

export default ModalsArea;
